module.exports = "/_next/static/images/tile4-5088bc1ad24183e14e3665f9f87dc66f.png";